<template>
  <b-modal id="modal-change-sync-name" title="Change Sync Fieldname" :ok-title="okTitle" :ok-only="success" @show="resetModal" @ok="changeSyncFieldname">
    <div>
      <div v-if="!success">
        <b-form @submit.prevent="changeSyncFieldname">
          <b-form-group
            id="sync-fieldname-group"
            label="Fieldname"
            label-for="fieldname"
          >
            <b-form-input
              id="fieldname"
              v-model="fieldName"
              type="text"

            ></b-form-input>
          </b-form-group>

        </b-form>
        <div>
          <b-alert :show="error" variant="danger">{{ errorMessage }}</b-alert>
        </div>
      </div>
      <div v-if="success">
        <b-alert :show="success" variant="success">{{ message }}</b-alert>

      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'ChangeFieldSyncName',  
  data () {
    return {
      message: '',
      errorMessage: '',
      fieldName: '',
      error: false,
      success: false,
	  schema: null
    }
  },
  computed: {
    okTitle: function () {
      return this.success ? 'OK' : 'Change Fieldname'
    }
  },
  methods: {
    resetModal (evt) {
	  this.schema = this.$store.state.selectedSchema
      this.success = false
      this.error = false
      this.$http.get('/api/currentSyncFieldname/' + this.schema.id ).then((response) => {
        console.log('received data ' + response.data)
        this.fieldName = response.data
      })
    },
    changeSyncFieldname (evt) {
      this.error = false
	  if (!this.success) {
        evt.preventDefault()

		if(this.fieldName == "")
		{
			this.error = true
            this.errorMessage = "Fieldname cannot be empty";
			return;
		}

        this.$http.post('/api/changeSyncFieldname/' + this.schema.id, this.fieldName).then((response) => {
          console.log('received msg ' + response.data.message)
          this.message = response.data.message
          this.success = true
          this.okTitle = 'OK'
        }).catch((err) => {
          console.log('error catched')
          if (err.response) {
            // Request made and server responded
            console.log(err.response.data)
            console.log(err.response.status)
            console.log(err.response.headers)
            this.error = true
            this.errorMessage = err.response.data.message
          } else if (err.request) {
            this.error = true
            this.errorMessage = 'Could not perform request'
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
            this.error = true
            this.errorMessage = 'Could not perform request'
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangeFieldSyncName.vue